import React from 'react';

const Indicator = ({formIndex, totalSteps = 4}) => {
    const currentStep = formIndex;
    const progress = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;

    const label = `Étape ${currentStep} sur ${totalSteps}`;

    return (
        <div className="flex items-center gap-4 flex-1 min-w-0">
            <div className="flex-1 min-w-0">
                <div className="mb-1.5">
                    <span className="text-sm font-medium text-gray-700">
                        {label}
                    </span>
                </div>
                <div className="h-2 w-full max-w-xs bg-gray-100 rounded-full overflow-hidden">
                    <div
                        className="bg-gradient-to-r from-yellow-400 to-yellow-500 h-full rounded-full transition-all duration-300 ease-out"
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Indicator;
